var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChipGeneric',{key:'item_'+_vm.item.value,attrs:{"item":_vm.computed_item},on:{"update":_vm.chip_clicked}})}
var staticRenderFns = []

export { render, staticRenderFns }